module.exports = __webpack_public_path__ + "static/media/design2.a2bc735a.jpg";